import React from "react";
import ContentLoader from "react-content-loader";
const MyLoader = (props) => (
	<div className="loader-table mt-4">
		<ContentLoader
			speed={2}
			// width={'100%'}
			height={975}
			viewBox="0 0 1200 875"
			backgroundColor="#f3f3f3"
			foregroundColor="#e5e5e5"
			{...props}
		>
			<rect x="230" y="25" rx="2" ry="2" width="115" height="6" />
			<circle cx="28" cy="40" r="11" />
			<rect x="230" y="39" rx="2" ry="2" width="115" height="6" />
			<rect x="230" y="52" rx="2" ry="2" width="115" height="6" />
			<rect x="114" y="28" rx="2" ry="2" width="19" height="26" />
			<rect x="16" y="108" rx="2" ry="2" width="1300" height="1" />
			<rect x="643" y="25" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="39" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="52" rx="2" ry="2" width="38" height="6" />
			<rect x="738" y="25" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="39" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="52" rx="2" ry="2" width="115" height="6" />
			<rect x="1004" y="28" rx="2" ry="2" width="19" height="26" />
			<rect x="1041" y="28" rx="2" ry="2" width="19" height="26" />
			<rect x="1076" y="28" rx="2" ry="2" width="19" height="26" />
			<rect x="230" y="152" rx="2" ry="2" width="115" height="6" />
			<circle cx="28" cy="167" r="11" />
			<rect x="230" y="166" rx="2" ry="2" width="115" height="6" />
			<rect x="230" y="179" rx="2" ry="2" width="115" height="6" />
			<rect x="114" y="155" rx="2" ry="2" width="19" height="26" />
			<rect x="16" y="235" rx="2" ry="2" width="1101" height="1" />
			<rect x="643" y="152" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="166" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="179" rx="2" ry="2" width="38" height="6" />
			<rect x="738" y="152" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="166" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="179" rx="2" ry="2" width="115" height="6" />
			<rect x="1004" y="155" rx="2" ry="2" width="19" height="26" />
			<rect x="1041" y="155" rx="2" ry="2" width="19" height="26" />
			<rect x="1076" y="155" rx="2" ry="2" width="19" height="26" />
			<rect x="230" y="283" rx="2" ry="2" width="115" height="6" />
			<circle cx="28" cy="298" r="11" />
			<rect x="230" y="297" rx="2" ry="2" width="115" height="6" />
			<rect x="230" y="310" rx="2" ry="2" width="115" height="6" />
			<rect x="114" y="286" rx="2" ry="2" width="19" height="26" />
			<rect x="16" y="366" rx="2" ry="2" width="1101" height="1" />
			<rect x="643" y="283" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="297" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="310" rx="2" ry="2" width="38" height="6" />
			<rect x="738" y="283" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="297" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="310" rx="2" ry="2" width="115" height="6" />
			<rect x="1004" y="286" rx="2" ry="2" width="19" height="26" />
			<rect x="1041" y="286" rx="2" ry="2" width="19" height="26" />
			<rect x="1076" y="286" rx="2" ry="2" width="19" height="26" />
			<rect x="230" y="410" rx="2" ry="2" width="115" height="6" />
			<circle cx="28" cy="425" r="11" />
			<rect x="230" y="424" rx="2" ry="2" width="115" height="6" />
			<rect x="230" y="437" rx="2" ry="2" width="115" height="6" />
			<rect x="114" y="413" rx="2" ry="2" width="19" height="26" />
			<rect x="16" y="493" rx="2" ry="2" width="1101" height="1" />
			<rect x="643" y="410" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="424" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="437" rx="2" ry="2" width="38" height="6" />
			<rect x="738" y="410" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="424" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="437" rx="2" ry="2" width="115" height="6" />
			<rect x="1004" y="413" rx="2" ry="2" width="19" height="26" />
			<rect x="1041" y="413" rx="2" ry="2" width="19" height="26" />
			<rect x="1076" y="413" rx="2" ry="2" width="19" height="26" />
			<rect x="230" y="542" rx="2" ry="2" width="115" height="6" />
			<circle cx="28" cy="557" r="11" />
			<rect x="230" y="556" rx="2" ry="2" width="115" height="6" />
			<rect x="230" y="569" rx="2" ry="2" width="115" height="6" />
			<rect x="114" y="545" rx="2" ry="2" width="19" height="26" />
			<rect x="16" y="625" rx="2" ry="2" width="1101" height="1" />
			<rect x="643" y="542" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="556" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="569" rx="2" ry="2" width="38" height="6" />
			<rect x="738" y="542" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="556" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="569" rx="2" ry="2" width="115" height="6" />
			<rect x="1004" y="545" rx="2" ry="2" width="19" height="26" />
			<rect x="1041" y="545" rx="2" ry="2" width="19" height="26" />
			<rect x="1076" y="545" rx="2" ry="2" width="19" height="26" />
			<rect x="230" y="673" rx="2" ry="2" width="115" height="6" />
			<circle cx="28" cy="688" r="11" />
			<rect x="230" y="687" rx="2" ry="2" width="115" height="6" />
			<rect x="230" y="700" rx="2" ry="2" width="115" height="6" />
			<rect x="114" y="676" rx="2" ry="2" width="19" height="26" />
			<rect x="16" y="756" rx="2" ry="2" width="1101" height="1" />
			<rect x="643" y="673" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="687" rx="2" ry="2" width="38" height="6" />
			<rect x="643" y="700" rx="2" ry="2" width="38" height="6" />
			<rect x="738" y="673" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="687" rx="2" ry="2" width="115" height="6" />
			<rect x="738" y="700" rx="2" ry="2" width="115" height="6" />
			<rect x="1004" y="676" rx="2" ry="2" width="19" height="26" />
			<rect x="1041" y="676" rx="2" ry="2" width="19" height="26" />
			<rect x="1076" y="676" rx="2" ry="2" width="19" height="26" />
		</ContentLoader>
	</div>
);

export default MyLoader;
